import { useTranslation } from "react-i18next";
import BusyRing from "../../../../components/BusyRing";

/**
 * „Закрива се" на мястото на сумата в картата на масата (`TableCard`), докато
 * закриването чака фискалния принтер — модалът „Закрий" вече е затворен и
 * спинерът е тук. Тих етикет долу вдясно, без фон, със спинер отпред. Редът
 * държи височината на сумата, която замества, за да не мърда картата.
 * Пръстенът е общият `BusyRing` (същият е и на масата в процес на закриване
 * в режим „Схема").
 */
export function TableCardClosingLabel({ compact }: { compact: boolean }) {
  const { t } = useTranslation();
  // Линия ~1.3px при всеки размер: viewBox-ът е 104, пръстенът — 16/12px.
  const ringStroke = compact ? 11 : 9;
  return (
    <span
      className={`ml-auto flex min-w-0 items-center font-semibold leading-[1.2] text-pos-muted ${
        compact ? "h-[13px] gap-1 text-[11px]" : "h-[19px] gap-1.5 text-[13px]"
      }`}
    >
      <BusyRing className={compact ? "h-3 w-3" : "h-4 w-4"} strokeWidth={ringStroke} />
      <span className="min-w-0 truncate">{t("ordering.tableClosing")}</span>
    </span>
  );
}
